import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import {
  Table, TableBody, TableCell, TableHead, TableHeader, TableRow,
} from "@/components/ui/table";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { PageHeader } from "@/pages/Accounts";

export default function ProjectsPage() {
  const [items, setItems] = useState(null);

  useEffect(() => {
    const load = async () => {
      try {
        const { data } = await api.get("/projects");
        setItems(data);
      } catch (e) {
        toast.error(formatApiError(e));
      }
    };
    load();
  }, []);

  return (
    <div className="p-8 space-y-6">
      <PageHeader
        title="Projects"
        description="Workspaces inside an account. Analysts only see projects they've been scoped to."
      />
      <Card data-testid="projects-page-card">
        <CardContent className="p-0">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Name</TableHead>
                <TableHead>Description</TableHead>
                <TableHead>Account</TableHead>
                <TableHead>Active</TableHead>
                <TableHead />
              </TableRow>
            </TableHeader>
            <TableBody>
              {items === null && (
                <TableRow>
                  <TableCell colSpan={5} className="text-center py-8">
                    <Loader2 className="inline h-4 w-4 animate-spin" />
                  </TableCell>
                </TableRow>
              )}
              {items?.length === 0 && (
                <TableRow>
                  <TableCell colSpan={5} className="text-center py-8 text-xs text-muted-foreground">
                    No projects visible to your scope.
                  </TableCell>
                </TableRow>
              )}
              {items?.map((p) => (
                <TableRow key={p.id} data-testid={`project-list-row-${p.id}`}>
                  <TableCell className="font-medium">
                    <Link to={`/projects/${p.id}`}
                          className="hover:underline text-primary"
                          data-testid={`project-name-link-${p.id}`}>
                      {p.name}
                    </Link>
                  </TableCell>
                  <TableCell className="text-xs text-muted-foreground">
                    {p.description || "—"}
                  </TableCell>
                  <TableCell className="font-mono text-xs">{p.account_id.slice(-6)}</TableCell>
                  <TableCell>
                    <Badge variant={p.is_active ? "default" : "secondary"}>
                      {p.is_active ? "active" : "inactive"}
                    </Badge>
                  </TableCell>
                  <TableCell className="text-right">
                    <Button variant="ghost" size="sm" asChild data-testid={`project-open-${p.id}`}>
                      <Link to={`/projects/${p.id}`}>Open</Link>
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </CardContent>
      </Card>
    </div>
  );
}
